import React from "react";
import { useSelector } from "react-redux";
import { headerMap, headerType } from "../../helpers/InPlayPopular.helper";
import SVG_InplayIcon from "../../assets/images/svgs/inplay.svg?react";
import SVG_UpcomingIcon from "../../assets/images/svgs/upcoming.svg?react";
import { useLocation, useNavigate } from "react-router-dom";
import { UNICON_THEME } from "../../config/api.config";

const InPlayPopularHeader = ({ type, orderCount }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getHeaderColor = () => {
    switch (type) {
      case headerType["INPLAY"]: {
        return "bg-inPlayBlockBg";
      }

      case headerType["POPULAR"]: {
        return "bg-UpcomingBg";
      }

      case headerType["FUTURE"]: {
        return "future-header-color";
      }
      default:
        return "bg-UpcomingBg";
    }
  };

  const getIcon = () => {
    switch (type) {
      case headerType["INPLAY"]: {
        return <SVG_InplayIcon />;
      }

      case headerType["POPULAR"]: {
        return <SVG_UpcomingIcon />;
      }

      case headerType["FUTURE"]: {
        return "";
      }

      default:
        return <SVG_InplayIcon />;
    }
  };

  const checkStateWidth = useSelector(
    (state) => state.elementsParams.clientWidth
  );
  const width = checkStateWidth ? checkStateWidth : window.innerWidth;

  return (
    <>
      <div
        className={` w-full flex items-center justify-between rounded-t-[3px] py-1.5 px-[7px]  ${getHeaderColor()}`}
        style={
          location.pathname.includes("sports-page")
            ? UNICON_THEME
             ?{
                backgroundImage: "linear-gradient(90deg,rgb(110, 8, 29),rgb(193, 9, 49))",
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
              }
            :{
                backgroundImage: "linear-gradient(90deg,#22c55d,#22c55d)",
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
              }
            : { borderTopLeftRadius: 10, borderTopRightRadius: 10 }
        }
      >
        <div className=" flex items-center text-text_Quaternary  font-semibold text-[18px] tracking-wide justify-start w-full gap-[5px] ">
          {getIcon()}
          <span>{headerMap[type]?.title}</span>
        </div>

        {headerMap[type]?.showBets && !location.pathname.includes("sports-page") && (
          <div
            className=" w-max text-nowrap"
            onClick={() => navigate("/open-bets")}
          >
            <span className=" text-xs tracking-wide text-text_Quaternary  text-nowrap whitespace-nowrap font-normal">
              Open Bets
            </span>
            <sup className="font-features sups">
              <span
                className="text-x font-normal tracking-wide text-text_color_primary2 bg-bg_brand_primary min-w-4 min-h-4  text-center px-1 py-0.5 font-lato rounded-full"
                style={{
                  backgroundImage:
                    "linear-gradient(89deg, #c10931, #6e081d 89.28%)",
                }}
              >
                {orderCount}
              </span>
              {/* <span className="text-x font-normal tracking-wide text-text_Ternary  bg-bg_Warning min-w-4 min-h-4  text-center px-1 py-0.5 font-lato rounded-full">{orderCount}</span> */}
            </sup>
          </div>
        )}
      </div>
    </>
  );
};

export default InPlayPopularHeader;
